import styled from 'styled-components';
export const Container = styled.div`
  border-radius: 50%;
  background-color: #4c5ecf;
  color: white;
  padding: 5px;
  display: inline-flex;
  align-items: center;
  transition: 0.2s ease-out background-color;
  justify-content: center;
  ${props => props.bgColor && `background-color: ${props.bgColor};`}

  &:after {
    content: '';
    display: block;
    height: 0;
    width: 100%;
    padding-bottom: 100%;
    box-sizing: border-box;
  }
`;
export const BadgeValue = styled.div`
  overflow: visible;
  height: 0;
  margin-top: -12px;
  line-height: 13px;
  font-size: 11px;
  font-weight: bold;
  font-family: Roboto, sans-serif;
`;